export interface ExtraFile {
  id: string;
  filename: string;
  mime_type: string;
  bytes: number;
  width: number;
  height: number;
  url: string;
  download_url: string;
}
export interface DigitalExtra {
  id: string;
  session_id?: string;
  product_id?: string;
  analytics?: Record<string, string | boolean | null> | null;
  title: string;
  price_minor: number;
  currency: string;
  payment_model: string;
  kind: 'video';
  status: 'queued' | 'running' | 'ready' | 'failed';
  error_code: string | null;
  files: ExtraFile[];
}

export async function prepareExtraFile(
  file: ExtraFile,
  signal: AbortSignal
): Promise<File> {
  const response = await fetch(file.url, { signal });
  if (!response.ok) {
    throw new Error('File unavailable');
  }
  const blob = await response.blob();
  if (blob.size !== file.bytes || blob.type.split(';')[0] !== file.mime_type) {
    throw new Error('Invalid file');
  }
  return new File([blob], file.filename, { type: file.mime_type });
}

export function canShareExtra(file: File): boolean {
  return (
    typeof navigator.share === 'function' &&
    typeof navigator.canShare === 'function' &&
    navigator.canShare({ files: [file] })
  );
}

export function extraAnalyticsProperties(
  extra: DigitalExtra
): Record<string, unknown> {
  return {
    ...extra.analytics,
    extra_order_id: extra.id,
    product_id: extra.product_id,
    product_kind: extra.kind,
    price_minor: extra.price_minor,
    currency: extra.currency,
    payment_model: extra.payment_model,
  };
}

export function extraAnalyticsSession(extra: DigitalExtra): string | undefined {
  const journey = extra.analytics?.journey_session_id;
  return typeof journey === 'string' ? journey : extra.session_id;
}
